// extracted by mini-css-extract-plugin
export default {"formSubmitButton":"SubmitButton_formSubmitButton__5PwYT","emoji":"SubmitButton_emoji__BaOQf"};